import React, { useState, useRef, useEffect } from 'react';
import styles from './fieldTreePopover.module.css';


function FieldTreePopover({ nodes, selected, onSelect, anchorRef, onClose }) {
  const [drillPath, setDrillPath] = useState([]);
  const popoverRef = useRef(null);

  // Close popover on outside click
  useEffect(() => {
    function handleClick(e) {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(e.target) &&
        (!anchorRef || !anchorRef.current || !anchorRef.current.contains(e.target))
      ) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [onClose, anchorRef]);

  // Get current node list to display
  const currentNodes = drillPath.length === 0 ? nodes : drillPath[drillPath.length - 1].children || [];
  const canGoBack = drillPath.length > 0;

  return (
    <div ref={popoverRef} style={{ position: 'absolute', zIndex: 100, minWidth: 320, maxWidth: 400, background: '#fff', boxShadow: '0 8px 24px rgba(0,0,0,0.12)', borderRadius: 12, border: '1px solid #e5e7eb', padding: 16, top: anchorRef?.current?.offsetTop + (anchorRef?.current?.offsetHeight || 0) + 8, left: anchorRef?.current?.offsetLeft || 0 }}>
      <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontWeight: 600, fontSize: '1rem', color: '#374151' }}>Select Field</span>
        {canGoBack && (
          <button className={styles.actionButton + ' ' + styles.closeButton} style={{ marginLeft: 'auto' }} onClick={() => setDrillPath(drillPath.slice(0, -1))}>
            ← Back
          </button>
        )}
        <button className={styles.actionButton + ' ' + styles.closeButton} style={{ marginLeft: canGoBack ? 8 : 'auto' }} onClick={onClose}>
          ✕
        </button>
      </div>
      <div style={{ maxHeight: 320, overflowY: 'auto' }}>
        {currentNodes && currentNodes.length > 0 ? (
          currentNodes.map((node) => (
            <div key={node.key} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', borderBottom: '1px solid #f3f4f6', cursor: node.children ? 'pointer' : 'default', background: selected === node.key ? '#f0f9ff' : 'transparent' }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 500, color: '#111827', fontSize: '0.95rem' }}>{node.label}</div>
                {node.value && <div style={{ color: '#6b7280', fontSize: '0.85rem' }}>{node.value}</div>}
              </div>
              {node.children ? (
                <button className={styles.actionButton + ' ' + styles.closeButton} style={{ fontSize: '0.85rem', padding: '2px 8px' }} onClick={() => setDrillPath([...drillPath, node])}>
                  Drill Down →
                </button>
              ) : (
                <button className={styles.actionButton} style={{ fontSize: '0.85rem', padding: '2px 8px', background: selected === node.key ? '#2563eb' : undefined }} onClick={() => { onSelect(node.key); onClose(); }}>
                  Select
                </button>
              )}
            </div>
          ))
        ) : (
          <div style={{ color: '#6b7280', textAlign: 'center', padding: '2rem 0' }}>No fields available</div>
        )}
      </div>
    </div>
  );
}

export default FieldTreePopover;
